import React, { useEffect, useState } from 'react';
import { Loading } from 'react-daisyui';

import { userLogout } from '../shared/api/user';
import { auth } from '../shared/firebase/firebase';

const LogoutPage: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>('');
  const handleLogout = async () => {
    try {
      setLoading(true);
      await userLogout();
      await auth.signOut();
    } catch (error: unknown) {
      setError((error as Error).message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleLogout();
  }, []);

  if (loading) {
    return (
      <div>
        <Loading />
      </div>
    );
  }

  return (
    <div>
      <h2>Logout Page</h2>

      {error && <p>{error}</p>}
    </div>
  );
};

export default LogoutPage;
